enum SettingsActionTypesEnum {
  SET_LANGUAGE = 'SET_LANGUAGE',
  SET_SPINNER_VISIBLE = 'SET_SPINNER_VISIBLE',
  SAVE_WHATSNEW_CONTENT = 'SAVE_WHATSNEW_CONTENT',
  SAVE_WHATSNEW_HASUPDATE = 'SAVE_WHATSNEW_HASUPDATE',
  SAVE_PARAM_CONFIGS = 'SAVE_PARAM_CONFIGS',
  SET_SELECTED_PARAM_CONFIG = 'SET_SELECTED_PARAM_CONFIG',
  SAVE_PARAM_PUBLIC_CONFIGURATION = 'SAVE_PARAM_PUBLIC_CONFIGURATION',
}

export default SettingsActionTypesEnum;
